module.exports = __webpack_public_path__ + "static/media/respect.6ca93f74.jpg";